import { render } from "./Screensaver.vue?vue&type=template&id=c926a2f8&scoped=true"
import script from "./Screensaver.vue?vue&type=script&lang=js"
export * from "./Screensaver.vue?vue&type=script&lang=js"

import "./Screensaver.vue?vue&type=style&index=0&id=c926a2f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c926a2f8"]])

export default __exports__